import { CodeSubject } from './code-subject-section';

export const keyAllHolders = [
  CodeSubject.INT_NAS_1,
  CodeSubject.INT_NAS_2,
  CodeSubject.INT_NAS_3,
  CodeSubject.INT_NAS_4,
  CodeSubject.INT_NAS_5,
  CodeSubject.INT_NAS_6,
  CodeSubject.INT_NAS_7,
  CodeSubject.INT_NAS_8,
  CodeSubject.INT_NAS_9,
  CodeSubject.INT_NAS_10,
  CodeSubject.INT_NAS_11,
  CodeSubject.INT_NAS_12,
  CodeSubject.INT_NAS_13,
  CodeSubject.INT_NAS_14,
  CodeSubject.INT_NAS_15,
  CodeSubject.INT_NAS_16,
  CodeSubject.INT_NAS_17,
  CodeSubject.INT_NAS_18,
  CodeSubject.INT_NAS_19,
  CodeSubject.INT_NAS_20,
];
